import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const get = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('gestiones'), { params });
};

const store = async (data) => {
  return await axiosIns.post(obtenerUrl('gestiones'), data);
};

const update = async (id, data) => {
  return await axiosIns.put(obtenerUrl(`gestiones/${id}`), data);
};

const destroy = async (id) => {
  return await axiosIns.delete(obtenerUrl(`gestiones/${id}`));
};

const activate = async (id) => {
  return await axiosIns.put(obtenerUrl(`gestiones/${id}/activar`));
};

const deactivate = async (id) => {
  return await axiosIns.delete(obtenerUrl(`gestiones/${id}/desactivar`));
};

export default {
  get,
  store,
  update,
  destroy,
  activate,
  deactivate,
};
